import { API_BASE_URL } from "../config/network";

export const toAttachmentUrl = (url) => {
  if (!url) return "";
  const safeUrl = String(url).trim();
  if (!safeUrl) return "";
  if (safeUrl.startsWith("http://") || safeUrl.startsWith("https://")) return safeUrl;
  if (safeUrl.startsWith("data:") || safeUrl.startsWith("blob:")) return safeUrl;
  const path = safeUrl.startsWith("/") ? safeUrl : `/${safeUrl}`;
  return `${API_BASE_URL}${path}`;
};

export const getAvatarSource = (entity) =>
  entity?.avatarUrl ||
  entity?.avatar ||
  entity?.profile?.avatarUrl ||
  entity?.profile?.avatar ||
  entity?.user?.avatarUrl ||
  entity?.user?.avatar ||
  entity?.photoUrl ||
  entity?.photoURL ||
  "";

const getEntityId = (entity) => entity?._id || entity?.id || "";

export const resolveAvatarUrl = (entity) => toAttachmentUrl(getAvatarSource(entity));

export const findDirectChatPeer = ({ roomUsers = [], roomMembers = [], currentUserId }) => {
  const mergedMembers = new Map();

  [...roomUsers, ...roomMembers].forEach((member) => {
    if (!member) return;
    const memberId = getEntityId(member);
    if (!memberId) return;
    mergedMembers.set(memberId, {
      ...(mergedMembers.get(memberId) || {}),
      ...member,
      profile: {
        ...(mergedMembers.get(memberId)?.profile || {}),
        ...(member.profile || {})
      },
      user: {
        ...(mergedMembers.get(memberId)?.user || {}),
        ...(member.user || {})
      }
    });
  });

  const normalizedCurrentUserId = String(currentUserId || "");
  const peerFromMerged = Array.from(mergedMembers.values()).find((member) => String(getEntityId(member)) !== normalizedCurrentUserId);
  if (peerFromMerged) return peerFromMerged;

  return [...roomUsers, ...roomMembers].find((member) => String(getEntityId(member)) !== normalizedCurrentUserId) || null;
};
